module.exports = require("date-fns/isValid");